export default __webpack_public_path__ + "static/media/diagram-en-mobile.7933ba11.jpg";